import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { PricePlan } from '@shared/price-plan/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({ providedIn: 'root' })
export class PricePlansApiService {
  private readonly basePath = '/v.1/pricePlans';

  constructor(private readonly http: ApiClientService) {}

  get(): Observable<PricePlan[]> {
    return this.http.get<any>(this.basePath).pipe(map(({ success, error, data }) => {
      if (success) {
        return data as PricePlan[];
      }

      throw new Error(String(error));
    }));
  }

  getByAccount(): Observable<PricePlan[]> {
    return this.http.get<PricePlan[]>(`${this.basePath}/account`);
  }
}
